import { Spinner } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import { classes } from './loader.st.css';
export const Loader = () => /*#__PURE__*/React.createElement("div", {
  className: classes.root
}, /*#__PURE__*/React.createElement(Spinner, {
  className: classes.spinner
}));
//# sourceMappingURL=index.js.map